import {Component, inject, Input} from '@angular/core';
import {RecordDataValue, SelectData} from "../../../../../types/records-table.types";
import {DynamicSelectStateService} from "../services/dynamic-select-state.service";
import {SnackbarService} from "../../../../../services/snackbar.service";
import {DynamicService} from "../services/dynamic.service";
import {GetSelectDataParams} from "../types/dynamic.types";
import {SingleSelectTableItemComponent} from "../single-select-table-item/single-select-table-item.component";

@Component({
  selector: 'app-dynamic-single-select-table-item',
  standalone: false,
  templateUrl: './dynamic-single-select-table-item.component.html',
  styleUrls: [
    '../../base-record-table-item-styles.scss',
    '../single-select-table-item/single-select-table-item.component.scss',
    './dynamic-single-select-table-item.component.scss'
  ]
})
export class DynamicSingleSelectTableItemComponent extends SingleSelectTableItemComponent {
  @Input({ required: true }) dynamicValue?: RecordDataValue;

  private dynamicSelectStateService: DynamicSelectStateService = inject(DynamicSelectStateService);
  private snackbarService: SnackbarService = inject(SnackbarService);
  private dynamicService: DynamicService = inject(DynamicService);

  private isProduct: boolean = false;

  public override ngOnInit() {
    super.ngOnInit();
    this.isProduct = this.columnParam.key === 'productId';
    this.selectData = this.dynamicSelectStateService.dynamicState()[this.columnParam.key];
  }

  public override getSelectedData(): SelectData | null {
    return this.selectData?.find((selectData: SelectData) =>
      selectData.id == this.value
    ) ?? null;
  }

  public override async handleSelectClick(): Promise<void> {
    this.selectData = await this.getOptions();
    if (!this.selectData?.length) {
      this.snackbarService.showMessage({
        type: 'info',
        message: 'Нет данных'
      });
    }

    this.changeDetectorRef.detectChanges();
    this.matSelect.open();
  }

  private async getOptions(): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      ...this.dynamicService.getDefaultSelectDataParams(this.isProduct),
      productIds: !this.isProduct ? this.dynamicValue ? [this.dynamicValue.toString()] : null : null,
      articles: this.isProduct ? this.dynamicValue ? [this.dynamicValue.toString()] : null : null
    };

    return await this.dynamicService.getSelectData(getSelectDataParams);
  }
}
